import { FormControl, Input, InputLabel } from '@mui/material'
import PropTypes                          from 'prop-types'
import React                              from 'react'

const ShortFormControl = (props) => {
  const {name, title, handleChange, value, defaultValue, inputProps, ...otherProps} = props
  return (
    <FormControl fullWidth variant="standard">
      <InputLabel htmlFor={`control-${name}`}>{title}</InputLabel>
      <Input
        id={`control-${name}`}
        name={name}
        value={value}
        onChange={handleChange ? handleChange(name) : undefined}
        inputProps={inputProps}
        defaultValue={defaultValue}
        {...otherProps}
      />
    </FormControl>
  )
}

ShortFormControl.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
}

export default ShortFormControl